import { DeliveryStatus } from '../../../domain/enum/DeliveryStatus.js';
export const OUT_FOR_DELIVERY_STATUSES = [
    DeliveryStatus.DELIVERY_APPOINTMENT_CANCELED,
    DeliveryStatus.DELIVERY_AT_CARRIER_NOT_PREALERTED,
    DeliveryStatus.DELIVERY_CHANGE_BY_CUSTOMER,
    DeliveryStatus.DELIVERY_CHANGE_IN_DELIVERY_DAY,
    DeliveryStatus.DELIVERY_CHANGE_TO_SAFE_PLACE,
    DeliveryStatus.DELIVERY_CUSTOMER_NOT_PRESENT_FORWARD_TO_PICK,
    DeliveryStatus.DELIVERY_CUSTOMER_NOT_PRESENT_SECOND_ATTEMPT,
    DeliveryStatus.DELIVERY_PREALERTED_NOT_AT_CARRIER,
    DeliveryStatus.DELIVERY_PROBLEM_1M_NOT_POSSIBLE,
    DeliveryStatus.DELIVERY_PROBLEM_ADDRESS_INCORRECT,
    DeliveryStatus.DELIVERY_PROBLEM_ADDRESS_NOT_ACCESSIBLE,
    DeliveryStatus.DELIVERY_PROBLEM_ADDRESS_NOT_ACCESSIBLE_SECOND_ATTEMPT,
    DeliveryStatus.DELIVERY_PROBLEM_ADDRESS_NOT_FOUND,
    DeliveryStatus.DELIVERY_PROBLEM_CUSTOMER_NOT_PRESENT_DELIVERY_CALENDAR,
    DeliveryStatus.DELIVERY_PROBLEM_PAYBACK_REJECTED_SERVICE,
    DeliveryStatus.DELIVERY_PROBLEM_PAYBACK_TIMEWINDOW,
    DeliveryStatus.DELIVERY_PROBLEM_PICKUP_FAIL,
    DeliveryStatus.DELIVERY_PROBLEM_SECOND_ATTEMPT,
    DeliveryStatus.DELIVERY_PROBLEM_SHIPMENT_CANCELED,
    DeliveryStatus.DELIVERY_PROBLEM_SHIPMENT_MANCO,
    DeliveryStatus.DELIVERY_PROBLEM_SHIPMENT_REFUSED,
    DeliveryStatus.DELIVERY_PROBLEM_WRONG_LABEL,
    DeliveryStatus.DELIVERY_RETURN_RETRIEVED_BY_PARTNER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_ALMOST_THERE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_AT_CARRIER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_AT_RIGHT_DEPOT,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_AVAILIBLE_FOR_PICKUP_LOCKER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DEF_LOST,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED_CLOSED_NOTIFICATION,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED_INCIDENT,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED_INFOSOURCE_TRACKTRACE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED_SAME_DAY,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED_WEATHER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DRIVER_EN_ROUTE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_NON_DELIVERABLE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_NOT_COLLECTED_ISSUE_NO_PARCEL,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_NOT_DELIVERED,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_OUT_FOR_DELIVERY,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_RETRIEVED_FROM_LOCKER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN_DUE_DAMAGE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN_DUE_ISSUE_ADDRESS,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN_NOT_PICKEDUP,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN_REQUEST_CUSTOMER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_TO_CARRIER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_TO_DEPOT,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_TIMESLOT_KNOWN,
    DeliveryStatus.DELIVERY_STATUS_UNKNOWN,
];
export const DELIVERED_STATUSES = [
    DeliveryStatus.DELIVERY_APPOINTMENT_CANCELED,
    DeliveryStatus.DELIVERY_AT_CARRIER_NOT_PREALERTED,
    DeliveryStatus.DELIVERY_CUSTOMER_NOT_PRESENT_FORWARD_TO_PICK,
    DeliveryStatus.DELIVERY_CUSTOMER_NOT_PRESENT_SECOND_ATTEMPT,
    DeliveryStatus.DELIVERY_PREALERTED_NOT_AT_CARRIER,
    DeliveryStatus.DELIVERY_PROBLEM_ADDRESS_NOT_FOUND,
    DeliveryStatus.DELIVERY_PROBLEM_CUSTOMER_NOT_PRESENT_DELIVERY_CALENDAR,
    DeliveryStatus.DELIVERY_PROBLEM_SHIPMENT_CANCELED,
    DeliveryStatus.DELIVERY_PROBLEM_SHIPMENT_MANCO,
    DeliveryStatus.DELIVERY_PROBLEM_SHIPMENT_REFUSED,
    DeliveryStatus.DELIVERY_PROBLEM_SHIPMENT_UNIT_DISCOUNT,
    DeliveryStatus.DELIVERY_PROBLEM_SHIPMENT_UNIT_PARTIAL_DELIVERY,
    DeliveryStatus.DELIVERY_RETURN_ARRIVED_AT_SENDER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_AT_CARRIER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_AT_RIGHT_DEPOT,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_AVAILIBLE_FOR_PICKUP,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED_CLOSED_NOTIFICATION,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELAYED_INFOSOURCE_TRACKTRACE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELIVERED,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELIVERED_ADDRESS,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELIVERED_LETTERBOX,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELIVERED_NEIGHBOUR,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELIVERED_RECIPIENT,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DELIVERED_SAFE_PLACE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_DRIVER_EN_ROUTE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_OUT_FOR_DELIVERY,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_RETRIEVED_FROM_PICKUP,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN_DUE_DAMAGE,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN_DUE_ISSUE_ADDRESS,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_RETURN_REQUEST_CUSTOMER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_TO_CARRIER,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_SEND_TO_DEPOT,
    DeliveryStatus.DELIVERY_SHIPMENTUNIT_TIMESLOT_KNOWN,
];
//# sourceMappingURL=deliveryStatuses.js.map